import { render, staticRenderFns } from "./proxy-product-editor.vue?vue&type=template&id=467ab8e0"
import script from "./proxy-product-editor.vue?vue&type=script&lang=js"
export * from "./proxy-product-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports